module.exports = __webpack_public_path__ + "static/media/model.175ce4b4.svg";